<template>
  <div id="classify" >
    <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
      <com-header ref="header"/>
      <div class="menu-content classify-menu">
        <h1>收藏</h1>
      </div>
      <div class="page-box-list-scroll" v-infinite-scroll="load" infinite-scroll-distance="800" infinite-scroll-delay="500">
        <div class="search-content ">
          <com-card :imgList="imgList" :total="imgRequest.total" v-if="imgList.length > 0" @collectCall="collectCall"/>
        </div>
      </div>
    </div>
    <el-backtop target=".page-box-list-scroll"></el-backtop>

  </div>

</template>

<script>
export default {
  name: "collect",
  data(){
    return {
      navDrawer: false,
      autoplay: false,
      activeName: '',
      navSelect: '',
      navPage: 1,
      imgRequest: {
        size: 9,
        page: 1,
      },
      imgList: [],
      loading: true,
      screenFlag: false,
      imgBg:''
    }
  },
  mounted() {
    this.getImgList()
    this.getImgBg({id:''})
  },
  methods: {
    getImgBg(params) {
      this.$get('/pc/shop/bgimg', params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    load() {
      if (this.imgRequest.total > this.imgList.length && this.loading) {
        this.loading = false
        this.imgRequest.page = this.imgRequest.page + 1
        this.getImgList()
      }
    },
    getImgList() {
      const loading = this.$loading({
        lock: false,
        text: '加载中....',
        spinner: 'el-icon-loading',
        customClass:'el-loading-com'
      });
      this.$get('/pc/shop/myCollect', this.imgRequest).then((res) => {
        loading.close();
        this.loading = true
        this.imgList = [...this.imgList, ...res.data]
        this.imgRequest.total = res.meta.total
      }).catch((error) => {
        this.loading = true
        this.$message.error(error.message);
        loading.close();
      })
    },
    getHandleImg(data,img) {
      if (data.length > 0) {
        let arr = []
        data.forEach((item) => {
          if(item.id !== img.id){
            arr.push( item.url)
          }
        })
        arr.unshift(img.url)
        return arr
      }
      return []
    },
    collectCall(data) {
      this.$refs.header.getCollect()
      this.imgList.forEach((item,index) => {
        if (item.id === data.id) {
          if (item.iscollect === 0) {
            item.iscollect = 1
            item.collection = Number(item.collection) + 1
          } else {
            item.iscollect = 0
            item.collection = Number(item.collection) - 1
            this.imgList.splice(index,1)
          }
        }
      })
    },
    clickLog(list, img) {
      this.$get('/pc/shop/clickLog', {packageid: list.id, imageid: img.id,phototag_id:window.getRequest().id,three_phototag_id:this.imgRequest.three_phototag_id}).then((res) => {
      })
    }
  }
}
</script>

<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/collect.vue